import {getScript} from './getScript'

let kPromise

export function getKlaviyoScript() {
	if (!kPromise) {
		kPromise = getScript('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js')
	}
	return kPromise
}